import React, { FC, useEffect, useState } from 'react'
import CustomPopup from '../Popup'
import CustomButton from '../Buttons/CustomButton'

import './ConfirmPopup.scss'

const ConfirmPopup: FC<any> = ({ isModalOpen, onClose, onConfirm, isInProgress, children }) => {
  return (
    <CustomPopup
      open={isModalOpen}
      buttonClose={onClose}
      closeOnDocumentClick={false}
      className='delete-modal'
    >
      <div className='delete-modal-wrapper'>
        {children}
        <div className='delete-modal_actions'>
          <CustomButton type='button' button='secondary' onClick={onClose}>
            No
          </CustomButton>

          <CustomButton
            type='button'
            button='primary'
            inProgress={isInProgress}
            onClick={onConfirm}
          >
            Yes
          </CustomButton>
        </div>
      </div>
    </CustomPopup>
  )
}

export default ConfirmPopup
